import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { MzBaseModal } from "ng2-materialize";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";

@Component({
  selector: "app-questionnaire-password-dialog",
  templateUrl: "./questionnaire-password-dialog.component.html",
  styleUrls: ["./questionnaire-password-dialog.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuestionnairePasswordDialogComponent extends MzBaseModal {
  readonly env: any = environment;

  password$: Observable<string>;
  canSubmit$: Observable<boolean>;

  @ViewChild("PasswordInput") passwordInput: ElementRef;

  constructor() {
    super();
    this.password$ = Observable.defer(() =>
      Observable.fromEvent(this.passwordInput.nativeElement, "keyup")
        .map((_) => this.passwordInput.nativeElement.value)
        .merge(this.modalComponent.onClose.delay(100).map((_) => ""))
    ).shareReplay();
    this.canSubmit$ = this.password$.map((x) => x && x.trim().length > 0);
  }

  ngAfterViewInit() {}

  submit() {
    this.modalComponent.close();
  }

  getResult(): Observable<string> {
    this.modalComponent.open();
    return this.modalComponent.onClose
      .withLatestFrom(this.password$)
      .map(([_, password]) => password)
      .do((_) => (this.passwordInput.nativeElement.value = ""));
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/questionnaire-password-dialog/questionnaire-password-dialog.component.ts